<p-toast
  key="lk-eu-notification"
  position="bottom-right"
  styleClass="notification-toast"
  #toast>
  <ng-template
    let-message
    pTemplate="message">
    <div
      *ngIf="toSocketNotification(message.data) as notification"
      class="w-full cursor-pointer"
      (click)="onNotificationClick(toast, notification)">
      <h4 class="mt-0 mb-3 font-bold">{{ notification.subject?.title || 'Новое уведомление' }}</h4>
      <h4 class="mt-0 mb-1 font-medium">
        {{ notification?.user?.profile?.name || notification?.externalUser?.profile?.name || 'Сервисное уведомление' }}
      </h4>
      <p
        class="notification-text break-word"
        [innerHTML]="notification.text | truncate: 70 | safeHtml"></p>
    </div>
  </ng-template>
</p-toast>
